module.exports = __webpack_public_path__ + "img/mitel_sm.ff446e1c.png";